<template>
  <div class="freeBet__item">
    <div class="freeBet__item_dot freeBets__dot"></div>
    <div class="freeBets__label_item">{{ spin.reward.betCount }}</div>
    <div class="freeBets__label_item">
      {{ getBetSpin(spin.reward.bet, spin.info.currency.decimals, spin.info.currency.code) }}
    </div>
    <div class="freeBets__label_item">
      {{ getBetSpin(spin.reward.win, spin.info.currency.decimals, spin.info.currency.code) }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'ArchiveFreeBet',
  props: {
    spin: {
      type: Object,
      required: true
    }
  },
  computed: {
    getFormatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.spin.info.currency.code);
    }
  },
  methods: {
    getBetSpin(bet: number, decimals: number, code: string): string {
      return Utils.centsToMoneyStr(bet, decimals, code) + ` ${this.getFormatedCurrency}`;
    }
  }
});
</script>

<style lang="scss" scoped>
.freeBet__item {
  cursor: auto;
}
</style>
